import {ReportMetricDetails, ReportMetricFormat, ReportMetricsAll} from './report-metric.enum';
export class ReportMetricUtils {

  static getMetricsOfFormat(formats: ReportMetricFormat[]): ReportMetricDetails[] {
    return ReportMetricsAll().filter(m => formats.includes(m.format));
  }

  static getNumericMetrics(): ReportMetricDetails[] {
    return ReportMetricUtils.getMetricsOfFormat([ReportMetricFormat.NUMBER, ReportMetricFormat.DECIMAL, ReportMetricFormat.CURRENCY,
      ReportMetricFormat.PERCENTAGE, ReportMetricFormat.PERCENTAGE_PLAIN])
  }

  static getNumericMetricsFields(): string[] {
    return ReportMetricUtils.getNumericMetrics().map(m => m.field)
  }
}
